import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
import React, { Component, Fragment } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { moneyColumn, moneyInline, numVal } from '../../../../modules/Utils'
import NumberColumn from '../../../../elements/Table/Columns/Number'
import { strVal } from '../../../../modules/Utils'

class PayLinesList extends Component {
  render() {
    const { fetchingReceipt, lines, handleChange, fetchLines, fetchingLines } = this.props

    const columns = [
      {
        Header: 'ID',
        accessor: '_id',
        hideable: true,
        hideDefault: true
      },
      {
        Header: 'Code',
        accessor: 'invoice.code',
        Cell: ({ value, original }) => (
          <a
            target={'_blank'}
            href={`#/clients/invoices/${strVal(original, 'invoice._id').replace(
              'invoices/',
              '',
            )}/view`}
            style={{ marginLeft: '10px' }}>
            {value}
          </a>
        ),
      },
      {
        Header: 'Date',
        accessor: 'invoice.date',
      },
      {
        Header: 'Amount',
        accessor: 'invoice.subTotal.gross',
        Cell: ({ value }) => moneyColumn(numVal({ value }, 'value')),
      },
      {
        Header: 'Paid',
        accessor: 'invoice.paid',
        Cell: ({ value }) => moneyColumn(numVal({ value }, 'value')),
      },
      {
        Header: 'Conv. Amount',
        accessor: 'converted.gross',
        Footer: SumFooter,
        Cell: ({ value, original }) => (
          <span>{moneyInline(value, strVal(original, 'converted.currency'))}</span>
        ),
      },
      {
        Header: 'Conv. Paid',
        accessor: 'converted.paid',
        Footer: SumFooter,
        Cell: ({ value, original }) => {
          return <span>{moneyInline(value, strVal(original, 'converted.currency'))}</span>
        },
      },
      {
        Header: 'Conv. Rate',
        accessor: 'converted.rate',
        Footer: SumFooter,
        Cell: MoneyCell,
      },
      {
        Header: 'Payment',
        accessor: 'amount',
        Cell: ({ value, original }) => (
          <NumberColumn
            dataIndex={'_key'}
            onChange={handleChange}
            value={value}
            record={original}
            column={'amount'}
          />
        ),
      },
      {
        Header: 'WH/ Tax',
        accessor: 'invoice.wtax.tax',
      },
      {
        Header: 'Discount',
        accessor: 'discount',
        Cell: ({ value, original }) => (
          <NumberColumn
            dataIndex={'_key'}
            onChange={handleChange}
            value={value}
            record={original}
            column={'discount'}
          />
        ),
      },
      {
        Header: 'Bank Fees',
        accessor: 'bankFees',
        Cell: ({ value, original }) => (
          <NumberColumn
            dataIndex={'_key'}
            onChange={handleChange}
            value={value}
            record={original}
            column={'bankFees'}
          />
        ),
      },
      {
        Header: 'Exchange Loss',
        accessor: 'exchangeLoss',
        Cell: ({ value, original }) => (
          <NumberColumn
            precision={2}
            dataIndex={'_key'}
            onChange={handleChange}
            value={value}
            record={original}
            column={'exchangeLoss'}
          />
        ),
      },
      {
        Header: 'New Balance',
        accessor: 'newBalance',
        Cell: ({ value, original }) => moneyColumn(numVal(original, 'newBalance')),
      },
    ]
    return (
      <Fragment>
        <CustomTable
          CreateButton={() => (
            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>Pay Lines</span>
          )}
          fetch={fetchLines}
          loading={fetchingLines || fetchingReceipt}
          columns={columns}
          data={lines}
          defaultPageSize={8}
        />
      </Fragment>
    )
  }
}

PayLinesList.propTypes = {}
PayLinesList.defaultProps = {}

export default PayLinesList
